import request from '@/services/interceptor.js'

export const get_fornitori = () => {
    return request({
        url: '/fornitore',
        method: 'get',
        loadingBar: true
    })
}

export const get_fornitore = (id) => {
    return request({
        url: `/fornitore/${id}`,
        method: 'get',
        loadingBar: true
    })
}

export const create_fornitore = (par) => {
    return request({
        url: '/fornitore',
        method: 'post',
        data: par,
        loadingBar: true
    })
}

export const update_fornitore = (id, par) => {
    return request({
        url: `/fornitore/${id}`,
        method: 'put',
        data: par,
        loadingBar: true
    })
}

export const duplica_fornitore = (id) => {
    return request({
        url: `/fornitore/${id}/duplica`,
        method: 'post',
        loadingBar: true
    })
}

export const delete_fornitore = (id) => {
    return request({
        url: `/fornitore/${id}`,
        method: 'delete',
        loadingBar: true
    })
}
